import { render, staticRenderFns } from "./SignUps.vue?vue&type=template&id=66c8cc86&"
import script from "./SignUps.vue?vue&type=script&lang=js&"
export * from "./SignUps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SignUps.vue"
export default component.exports